import {USER_AD_CATEGORIES} from '../../seller.js'
import {getConfigFields, getEmptyFieldRule, getRemoteFieldRule} from '../fields.js'
import {formFieldIds} from '../values.js'
import {formPublishAdClassicBikeFormConfig} from './publishAdClassicBikeFormConfig.js'
import {formPublishAdMinibikeFormConfig} from './publishAdMinibikeFormConfig.js'

const {
  comments,
  makeId,
  modelId,
  fuelId,
  yearId,
  versionId,
  hidePhone,
  kilometersId,
  price,
  colour,
  colourExtra,
  environmentalLabel
} = formFieldIds

const formPublishAdFieldsConfig = [
  getConfigFields[makeId](),
  getConfigFields[fuelId](),
  getConfigFields[yearId](),
  getConfigFields[modelId](),
  getConfigFields[versionId](),
  getConfigFields[environmentalLabel](),
  getConfigFields[colour](),
  getConfigFields[colourExtra](),
  getConfigFields[kilometersId](),
  getConfigFields[price]()
]

const formPublishAdFieldsWithRemotePropertyOrder = [makeId, fuelId, yearId, modelId, versionId]

const getFormPublishAdRules = () => {
  const rules = {}

  formPublishAdFieldsWithRemotePropertyOrder.forEach((fieldId, fieldIdIndex) => {
    if (!fieldIdIndex) return
    const previousFields = formPublishAdFieldsWithRemotePropertyOrder.slice(0, fieldIdIndex)
    const fieldRules = previousFields.map((previousFieldId, previousFieldIdIndex) => {
      return previousFieldIdIndex === previousFields.length - 1
        ? getRemoteFieldRule({id: previousFieldId})
        : getEmptyFieldRule({id: previousFieldId})
    })
    rules[fieldId] = fieldRules
  })

  return rules
}

const formPublishAdInitialValues = {
  [colour]: '',
  [colourExtra]: '',
  [comments]: '',
  [environmentalLabel]: 'UNSPECIFIED',
  [fuelId]: '',
  [hidePhone]: true,
  [kilometersId]: '',
  [makeId]: '',
  [modelId]: '',
  [price]: '',
  [yearId]: ''
}

export const formPublishAdFormConfig = {
  fields: formPublishAdFieldsConfig,
  initialValues: formPublishAdInitialValues,
  lockedFieldsOnEdition: [makeId, fuelId, yearId, modelId],
  remotes: formPublishAdFieldsWithRemotePropertyOrder,
  rules: getFormPublishAdRules()
}

export const formPublishAdFormConfigByCategory = {
  [USER_AD_CATEGORIES.CLASSIC_BIKE]: formPublishAdClassicBikeFormConfig,
  [USER_AD_CATEGORIES.MINIBIKE]: formPublishAdMinibikeFormConfig
}
